
const width = window.innerWidth;

const getWidthWeighingStationCode = () => {
    switch (width){
        case 1920:
            return 160
        case 1792:
            return 150
        case 1680:
        case 1600:
            return 140
        case 1536:
            return 130
        case 1440:
            return 140
        case 1366:
            return 150
        default:
            return ""
    }
}
const getWidthWeighingStationName = () => {
    switch (width){
        case 1920:
            return 318
        case 1792:
            return 300
        case 1680:
        case 1600:
            return 280
        case 1536:
            return 240
        case 1440:
            return 200
        case 1366:
            return 180
        default:
            return ""
    }
}
const getWidthAddress= () => {
    switch (width){
        case 1920:
            return 434
        case 1792:
            return 400
        case 1680:
        case 1600:
            return 380
        case 1536:
            return 340
        case 1440:
            return 300
        case 1366:
            return 250
        default:
            return ""
    }
}

const getWidthCustomerName= () => {
    switch (width){
        case 1920:
            return 222
        case 1792:
            return 200
        case 1680:
            return 180
        case 1600:
            return 170
        case 1536:
            return 150
        case 1440:
        case 1366:
            return 140
        default:
            return ""
    }
}
const getWidthPhoneNumber= () => {
    switch (width){
        case 1920:
            return 180
        case 1792:
            return 150
        case 1680:
            return 160
        case 1600:
            return 170
        case 1536:
        case 1366:
            return 180
        case 1440:
            return 190
        default:
            return ""
    }
}
const getWidthStatus= () => {
    switch (width){
        case 1920:
            return 180
        case 1792:
            return 150
        case 1680:
        case 1600:
            return 140
        case 1536:
            return 130
        case 1440:
            return 140
        case 1366:
            return 150
        default:
            return ""
    }
}

export const columns = [
    {
        title: "Mã trạm cân",
        dataIndex: "weighingStationCode",
        ellipsis: true,
        width: getWidthWeighingStationCode()
    },
    {
        title: "Trạm cân",
        dataIndex: "weighingStationName",
        ellipsis: true,
        width: getWidthWeighingStationName()
    },

    {
        title: "Địa chỉ",
        dataIndex: "address",
        ellipsis: true,
        width: getWidthAddress()
    },
    {
        title: "Khách hàng",
        dataIndex: "customerName",
        ellipsis: true,
        width: getWidthCustomerName(),
        onCell: record => {
            return {
                onClick: event => {
                    event.stopPropagation();
                }
            }
        },
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        ellipsis: true,
        width: getWidthPhoneNumber()
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        width: getWidthStatus()
    }
];
